export default "/_next/static/chunks/fonts/Roboto-BoldItalic-latin-6aa752727e30e357c8b23fac02891921.woff2";